









import { Component } from 'vue-property-decorator'

import Field from './Field.vue'
import Counter from '@/components/common/Counter.vue'

@Component({
  components: { Counter }
})
export default class FieldNumber extends Field {

  get currentValue() {
    const intVal = parseInt(this.field.value, 10) || 0
    const intDropVal = parseInt(this.field.dropoffValue, 10) || 0

    return this.isSecond ? (this.field.dropoff ? intDropVal : intVal) : intVal
  }

  beforeUpdateField(field, value) {
    this.updateField(field, value.toString())
  }
}
